export const CARRIER_SCAC_OTHER = 'OTHR';
export const RATE_SOURCE_CATAPULT = 'catapult-qms';
